import styled from "styled-components";

import { colors, radii } from "shared/ui/tokens";

/*
* На широком экране список скроллится внутри себя, чтобы диалог не вырастал на пол-экрана.
* На узком диалог и так открывается во весь экран — там ограничение только оставляло бы
* пустое место под списком, поэтому скроллим всё содержимое целиком.
* */
export const Results = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-height: 320px;
    overflow-y: auto;

    @media (max-width: 700px) {
        max-height: none;
        overflow-y: visible;
    }
`;

export const ResultRow = styled.button`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
    width: 100%;
    padding: 10px 12px;
    border: 1px solid ${colors.borderSoft};
    border-radius: ${radii.base};
    background: ${colors.surface};
    text-align: left;
    cursor: pointer;

    &:hover {
        border-color: ${colors.primary};
    }
`;

export const ResultName = styled.span`
    font-size: 0.9375rem;
    font-weight: 600;
    color: ${colors.textPrimary};
    overflow-wrap: break-word;
`;

export const ResultMeta = styled.span`
    font-size: 0.8125rem;
    color: ${colors.textSecondary};
`;

